import React from "react";
// Material imports
import Grid from "@mui/material/Grid";
//limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useNavigation } from "@limitless/portal";
import TextButton from "@limitless/portal/components/buttons/text-button/TextButton";
import { useTranslation } from "@limitless/common/hooks";
const ContactSupport = () => {
  const {
    navigate
  } = useNavigation();
  const {
    t
  } = useTranslation();
  const handleClickContactUs = () => {
    navigate("/contactusscreen");
  };
  return /*#__PURE__*/React.createElement(Grid, {
    style: {
      display: "flex",
      alignItems: "baseline",
      color: theme => theme.palette.grey[4]
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Please"), /*#__PURE__*/React.createElement(TextButton, {
    onClick: handleClickContactUs,
    style: {
      padding: "0px 5px",
      textTransform: "capitalize"
    }
  }, t("Contact Support")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "if you need to change your profile information"));
};
export default ContactSupport;